export default __webpack_public_path__ + "static/media/2-reducao-custos.08c6132e.svg";